import { format } from 'date-fns';
import { TimeIntervalTypeValues } from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';
import { MealCreditInfoTextProps } from './constructMealCreditInfoText.utils';

export function formatTimeInterval(
  props: Pick<
    MealCreditInfoTextProps,
    'startDate' | 'endTimeFullDate' | 'timeIntervalType'
  >
): string {
  const { startDate, endTimeFullDate, timeIntervalType } = props;

  if (timeIntervalType === TimeIntervalTypeValues.ALL_DAY) {
    return 'All day';
  }

  const startTime = format(startDate, 'h:mm a');
  const endTime = format(endTimeFullDate, 'h:mm a');

  const isOvernight = timeIntervalType === TimeIntervalTypeValues.OVERNIGHT;
  const overnightSuffix = isOvernight ? ' (next day)' : '';
  return `${startTime} - ${endTime}${overnightSuffix}`;
}
